// extracted by mini-css-extract-plugin
export default {"messageList":"MessageList_messageList__x-taE"};